var _excluded = ["icon", "content", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { Inbox } from '../../common/icons';
export function Empty(props) {
  var empty = useLocale('empty.text');

  var icon = props.icon,
      _props$content = props.content,
      content = _props$content === void 0 ? empty : _props$content,
      children = props.children,
      className = props.className,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = classnames(usePrefixCls('empty'), className);
  var innerCls = usePrefixCls('empty-inner');
  var iconCls = usePrefixCls('empty-icon');
  var textCls = usePrefixCls('empty-inner-text');

  var renderChildren = function renderChildren() {
    if (children) {
      return React.createElement("div", {
        className: innerCls
      }, children);
    }

    return React.createElement("div", {
      className: innerCls
    }, React.createElement("div", {
      className: iconCls
    }, icon ? icon : React.createElement(Inbox, null)), React.createElement("div", {
      className: textCls
    }, content));
  };

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls
  }), renderChildren());
}